import { Container, Modal } from "react-bootstrap";

const AllocationConfirmationModal = ({
  coderAllocationEvent,
  setAllocateEDCoder,
  showConfirmationModal,
  setShowConfirmationModal,
}) => {
  return (
    <Container>
      <Modal
        show={showConfirmationModal}
        onHide={() => setShowConfirmationModal(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure that you want to allocate this chart to a coder as this
          will not be visible in his priority bucket today because Received date
          is today?
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-secondary"
            onClick={() => {
              setShowConfirmationModal(false);
              setAllocateEDCoder("");
            }}
          >
            No
          </button>
          <button
            className="btn btn-primary"
            onClick={() => {
              setShowConfirmationModal(false);
              setAllocateEDCoder(coderAllocationEvent);
            }}
          >
            <span> {"Yes"}</span>
          </button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default AllocationConfirmationModal;
